import { BASE_CDN_URL, BASE_SITE_URL, SITE_NAME, joinUrl, trimUrl } from "./siteBase";

// Single source of truth for the product's public URLs on the client.
// Override per environment with VITE_APP_URL / VITE_CDN_URL; defaults come
// from site.config.json via siteBase (which is safe to share with Convex).
export { SITE_NAME };
export const SITE_URL = trimUrl(import.meta.env.VITE_APP_URL || BASE_SITE_URL);
export const SITE_HOST = new URL(SITE_URL).host;
export const SITE_DOMAIN = SITE_HOST.replace(/:\d+$/, "");
export const CDN_URL = trimUrl(import.meta.env.VITE_CDN_URL || BASE_CDN_URL);

export const siteUrl = (path = "") => joinUrl(SITE_URL, path);
export const cdnUrl = (path = "") => joinUrl(CDN_URL, path);
export const siteEmail = (local: string) => `${local}@${SITE_DOMAIN}`;

export const SUPPORT_EMAIL = siteEmail("support");
export const LEGAL_EMAIL = siteEmail("legal");
export const PRIVACY_EMAIL = siteEmail("privacy");
export const COPYRIGHT_EMAIL = siteEmail("copyright");
export const OG_IMAGE_URL = cdnUrl("/static/og.png");
export const LOGO_URL = cdnUrl("/logo-sq.png");
